import React from 'react';
import cn from 'classnames';
import { useRouter } from 'next/router';
import FacebookIcon from '../../svgs/facebook.svg';
import LinkedInIcon from '../../svgs/linkedin.svg';
import TwitterIcon from '../../svgs/twitter.svg';

interface Props {
  className?: string;
}

const SocialSharing = ({ className }: Props) => {
  const { asPath } = useRouter();
  const url = `${process.env.UI_URL}${asPath}`;
  const urlFragment = encodeURIComponent(url);

  return (
    <div
      className={cn('bg-abn-orange p-4 text-center font-heading', className)}
    >
      <p className='mb-2'>Share this article</p>
      <div className='flex justify-center'>
        <a
          href={`https://facebook.com/sharer/sharer.php?u=${urlFragment}`}
          target='_blank'
          rel='noreferrer'
          aria-label='Share on Facebook'
        >
          <FacebookIcon className='h-6 w-6 mr-4' />
        </a>
        <a
          href={`https://www.linkedin.com/shareArticle/?mini=true&url=${urlFragment}`}
          target='_blank'
          rel='noreferrer'
          aria-label='Share on LinkedIn'
        >
          <LinkedInIcon className='h-6 w-6 mr-4' />
        </a>
        <a
          rel='noreferrer'
          href={`https://twitter.com/intent/tweet?url=${urlFragment}`}
          target='_blank'
          aria-label='Share on Twitter'
        >
          <TwitterIcon className='h-6 w-6' />
        </a>
      </div>
    </div>
  );
};

export default SocialSharing;
